/**
 * Deliberately not extending Service: its failure handler pops a dialog, and an
 * attempt to freshen an expired image URL happens in the background - the user
 * did nothing to trigger it and there is nothing for them to do about it. A
 * failure here just means the placeholder stays.
 */
export default class MediaService {
  /**
   * @param {"image"|"attachment"} type
   * @param {number|string} id
   * @returns {Promise<{url: ?string, thumb_url: ?string}>}
   */
  freshUrls(type, id) {
    const path = type === "attachment" ? "attachments" : "images";

    return axios
      .get(`${env.API_URL}/${path}/${id}/url`)
      .then(response => response.data);
  }
}
